import { MenuItem, menuItemTemplate as template } from '@microsoft/fast-foundation';
import { MenuItemComponent } from './MenuItem';
import styles from './MenuItem.styles.scss';
export const menuItemDefinition = {
    baseName: 'menu-item',
    baseClass: MenuItem,
    template: template,
    styles,
    attributes: ['disabled', 'size'],
};
export const chameleonMenuItem = MenuItemComponent.compose(menuItemDefinition);
